export const HANDLE_UNCAUGHT_EXCEPTION = 'HANDLE_UNCAUGHT_EXCEPTION';

function requestHandleUncaughtException(exception) {
  return {
    type: HANDLE_UNCAUGHT_EXCEPTION,
    code: 0,
    message: exception.message
  };
}

export function handleUncaughtException(exception, callbackActionCreator, _showAlert) {
  return (dispatch) => {
    if (callbackActionCreator && typeof callbackActionCreator === 'function') {
      return dispatch(callbackActionCreator(exception.data));
    }
    return dispatch(requestHandleUncaughtException(exception));
  };
}
